import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import axios from "helpers/axiosInstance";
import { composeApiURL } from "helpers/utility/axiosHelpers";

import { State } from "redux/store";
import { SET_IMAGE_CUSTOM_METADATA } from "./constants";
import { ImageCustomMetadata } from "types";

export const setImageCustomMetadata = (data: ImageCustomMetadata[]) => {
  return { type: SET_IMAGE_CUSTOM_METADATA, data };
};

export const fetchImageCustomMetadata = (
  datasetId: string,
  imageId: string,
): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/datasets/${datasetId}/image/${imageId}/custom_metadata`,
      );

      const response = await axios.get(url);
      dispatch(setImageCustomMetadata(response.data || []));
    } catch (error) {
      console.log("Error fetching image custom metadata", error);
    }
  };
};
